module.exports = __webpack_public_path__ + "img/fast-start-photo.7ca1e25.jpg";